import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select.tsx";

interface MonthPickerProps {
  month: number;

  // Month is a number from 0 to 12
  // 0 is the last 30 days
  // 1 is January and so on
  setMonth: (month: number) => void;

  showLast7Days?: boolean;
  showLast30Days?: boolean;
  monthsToShow?: number;
  showYear?: boolean;
  className?: string;
}

// Function to generate the last 12 months including "Last 30 days"
const generateMonths = (
  showLast7Days: boolean,
  showLast30Days: boolean,
  monthsToShow: number,
  showYear: boolean,
) => {
  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();
  const months = [];

  // Determine the starting number for actual months based on what special options are shown
  let monthNumberOffset = 0;

  if (showLast7Days) {
    months.push({ name: "Last 7 days", number: -1 });
    monthNumberOffset = 1;
  }

  if (showLast30Days === true) {
    months.push({ name: "Last 30 days", number: 0 });
    if (!showLast7Days) {
      monthNumberOffset = 1;
    }
  }

  for (let i = 0; i < monthsToShow; i++) {
    const monthDate = new Date(currentYear, currentMonth - i, 1);
    const monthName = monthDate.toLocaleString("default", { month: "long" });
    const year = monthDate.getFullYear();
    const monthNumber = monthDate.getMonth() + monthNumberOffset;
    if (showYear || year !== currentYear) {
      months.push({ name: `${monthName} ${year}`, number: monthNumber });
    } else {
      months.push({ name: monthName, number: monthNumber });
    }
  }

  return months;
};

export function MonthPicker({
  month,
  setMonth,
  showLast7Days = false,
  showLast30Days = false,
  monthsToShow = 12,
  showYear = false,
  className,
}: MonthPickerProps) {
  const MONTHS = generateMonths(
    showLast7Days,
    showLast30Days,
    monthsToShow,
    showYear,
  );

  return (
    <Select
      value={month.toString()}
      onValueChange={(month) => {
        setMonth(parseInt(month, 10));
      }}
    >
      <SelectTrigger className={`w-full ${className}`}>
        <SelectValue placeholder="Month" />
      </SelectTrigger>
      <SelectContent>
        {MONTHS.map((m, i) => (
          <SelectItem key={i} value={"" + m.number}>
            {m.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
